<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="80px">
          <el-form-item label="配置类型：">
            <el-radio-group v-model="activeTable" @change="handleRadioChange">
              <el-radio border size="small" :label="2">最低价格</el-radio>
              <el-radio border size="small" :label="1">主推型号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="姓名：" prop="goodsCode">
            <el-select v-model="searchForm.userName" filterable>
              <el-option v-for="item in userData" :label="item.userName" :key="item.userName" :value="item.userName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺" v-if="activeTable == 1">
            <el-select v-model="searchForm.storeCode" filterable placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in useObjectList" :label="item.name" :key="item.code" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" @click="addDialogShow">新增</el-button>
      </template>
      <el-table
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        ref="table"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :height="maxTableHeight"
        :data="tableData.records"
        border
        style="width: 100%"
      >
        <el-table-column fixed prop="storeName" label="店铺" align="center" :show-overflow-tooltip="true" v-if="activeTable == 1" />
        <el-table-column fixed prop="userName" label="姓名" align="center" :show-overflow-tooltip="true" />
        <el-table-column prop="account" label="账号" align="center" :show-overflow-tooltip="true" />
        <el-table-column prop="createdDate" label="创建时间" align="center" :show-overflow-tooltip="true" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="del(scope.row)" class="red-text-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            :total="paginationOpt.total"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <!--新增/编辑弹框-->
    <el-dialog :visible.sync="addDialogVisible" :title="titleName" width="350px" @close="closeAddForm" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="60px">
        <el-form-item label="店铺：" v-if="activeTable == 1">
          <el-select v-model="form.storeCodeList" multiple collapse-tags filterable>
            <el-option v-show="!all" label="全部" value=""></el-option>
            <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in useObjectList" :label="item.name" :key="item.code" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名：">
          <el-select v-model="form.userId" filterable @change="userIdChanghe">
            <el-option v-for="item in userData" :label="item.userName" :key="item.userId" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号：" prop="goodsCode">
          <el-input class="form-input" v-model="form.userAccount" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: right">
        <el-button @click="closeAddForm">取消</el-button>
        <el-button type="primary" @click="modifStore"> 确认 </el-button>
      </div>
    </el-dialog>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
export default {
  name: "ProductComparison",
  mixins: [pagePathMixin, tableMixin],
  components: {},
  data() {
    return {
      activeTable: 2,
      loading: false,
      addDialogVisible: false,
      titleName: "新增",
      formData: {},
      form: {
        storeCodeList: [],
      },
      searchForm: {},
      useObjectList: [],
      optionsn: [],
      inputIndex: 9,
      userData: [],
      tableData: {
        records: [],
      },
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      all: false,
    };
  },
  computed: {
    storeCodeList() {
      return JSON.parse(JSON.stringify(this.form.storeCodeList));
    },
  },
  watch: {
    storeCodeList: {
      handler(val, oldval) {
        if (val.includes("")) {
          this.form.storeCodeList = [].concat(this.useObjectList).map((v) => v.code);
          this.all = true;
        } else if (val.includes("cancleAll")) {
          this.all = false;
          this.form.storeCodeList = [];
        }
      },
    },
  },
  mounted() {
    this.init();
    this.userList();
    this.salesGetStore();
  },
  methods: {
    onSearch() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    onReset() {
      this.searchForm = {
        storeCode: "",
      };
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    init() {
      this.tableData = [];
      if (this.activeTable == 2) {
        this.loading = true;
        let formData = {
          exportTag: true,
          pageNum: this.paginationOpt.pageNum,
          pageSize: this.paginationOpt.pageSize,
          filterData: {
            ...this.searchForm,
          },
        };
        this.$q.intelligentRecom
          .minAmountListPage({ data: formData })
          .then((res) => {
            if (res.data.records.length && res.code == 200) {
              this.tableData = res.data;
              console.log(res.data);
              this.paginationOpt["total"] = res.data.total;
            } else {
              this.paginationOpt["total"] = 0;
              this.tableData = [];
            }
          })
          .finally((_) => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        let formData = {
          exportTag: true,
          pageNum: this.paginationOpt.pageNum,
          pageSize: this.paginationOpt.pageSize,
          filterData: {
            ...this.searchForm,
          },
        };
        this.$q.intelligentRecom
          .mainPushModelListPage({ data: formData })
          .then((res) => {
            if (res.data.records.length && res.code == 200) {
              this.paginationOpt["pageNum"] = 1;
              this.tableData = res.data;
              this.paginationOpt["total"] = res.data.total;
            } else {
              this.paginationOpt["pageNum"] = 1;
              this.paginationOpt["total"] = 0;
              this.tableData = [];
            }
          })
          .finally((_) => {
            this.loading = false;
          });
      }
    },
    handleRadioChange() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    userIdChanghe(val) {
      let data = this.userData.filter((v) => v.userId == val);
      this.form.userId = data[0].userId;
      this.form.userName = data[0].userName;
      this.form.userAccount = data[0].userAccount;
    },
    addDialogShow() {
      this.titleName = "新增";
      this.addDialogVisible = true;
    },
    async del(row) {
      let status = await this.$confirm("是否确认删除该条数据？", "提示", { type: "warning" });
      if (status !== "confirm") return;
      this.$q.intelligentRecom.deleteAmountModel({ fragment: [row.dataId] }).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.init();
        }
      });
    },
    userList() {
      this.$q.intelligentRecom.userMsgList({}).then((res) => {
        if (res.code == 200) {
          this.userData = res.data;
        }
      });
    },
    modifStore(type) {
      let data = {
        type: this.activeTable,
        ...this.form,
      };
      this.$q.intelligentRecom.addAmountModel({ data: data }).then((res) => {
        if (res.code == 200) {
          this.$message.success("新增成功");
          this.init();
        }
      });
      this.addDialogVisible = false;
    },
    closeAddForm() {
      this.addDialogVisible = false;
      this.form = {
        storeCodeList: [],
      };
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      console.log(val);
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      if (this.checkAll) {
        this.print = [];
        this.checkAll = [];
      }
      this.searchType = true;
      this.paginationOpt.pageNum = val;
      this.init();
    },
    salesGetStore() {
      this.$q.intelligentRecom.getStore({}).then((res) => {
        this.useObjectList = res.data;
        if (res.data[0].whetherDef == "1") {
          this.$set(this.searchForm, "storeCode", res.data[0].code);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.footerBox
  text-align right
>>> .el-dialog .el-input
  width 100%
>>> .el-dialog .el-select
  width 100%
</style>
